import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'react-intl'
import { get } from 'lodash'
import { Image } from 'containers/misc'
import { ElevatedBox, Card } from 'components/layout'
import { ActivityProgress } from 'components/misc'
import { ACTIVITY_STATES } from 'constants/enums'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from './participant-item-wrap.styl'


class ParticipantItemWrap extends PureComponent {
  static propTypes = {
    activityName: PropTypes.string.isRequired,
    activitySection: PropTypes.string,
    avatar: PropTypes.string,
    completedPercentage: PropTypes.number,
    isAssessmentPositive: PropTypes.bool,
    isAwardLeaderSignoff: PropTypes.bool,
    setup: PropTypes.bool,
    revised: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    sectionIcon: PropTypes.object,
    state: PropTypes.object,
    activityId: PropTypes.number.isRequired,
    handleOpenAcceptActivityModal: PropTypes.func.isRequired
  }

  render() {
    const {
      activityName,
      activitySection,
      avatar,
      completedPercentage,
      isAssessmentPositive,
      setup,
      revised,
      isAwardLeaderSignoff,
      name,
      onClick,
      sectionIcon,
      state,
      handleOpenAcceptActivityModal
    } = this.props

    return (
      <div className={styles[getActivityClassName(activitySection)]}>
        <ElevatedBox onClick={onClick} clickable>
          <Card.Wrap>
            <Card.Left>
              {avatar ? (
                <Image
                  className={styles.avatar}
                  src={avatar}
                  alt="Participant Avatar"
                />
              ) : (
                <div className={styles.noAvatar}>
                  <span className="ico ico--user" />
                </div>
              )}
            </Card.Left>
            <Card.Content>
              <Card.Top>
                <Card.Middle>
                  <h3 className={styles.name}>{name}</h3>

                  <p className={styles.activity}>{activityName}</p>
                </Card.Middle>
                <Card.Right>
                  <div className={styles.sectionIcon}>
                    {get(sectionIcon, 'add') && <i className="ico ico--add" />}
                    {get(sectionIcon, 'pending') && (
                      <i className="ico ico--update" />
                    )}
                    {get(sectionIcon, 'checked') && (
                      <i className="ico ico--checked" />
                    )}
                  </div>
                </Card.Right>
              </Card.Top>
              {![null, undefined].includes(completedPercentage) && (
                <Card.Bottom className={styles.progress}>
                  <ActivityProgress
                    activitySection={activitySection}
                    completedPercentage={completedPercentage}
                  />
                </Card.Bottom>
              )}
              {activitySection === 'RESIDENTIAL_PROJECT' && (
                <Card.Bottom className={styles.progress}>
                  <div className={styles.progressWrap}>
                    <div className={styles.progressItem}>
                      <ActivityProgress
                        activitySection={activitySection}
                        completedPercentage={
                          state === ACTIVITY_STATES.setup.id ? 0 : 100
                        }
                      />
                    </div>
                    <div
                      className={`${styles.progressItem} ${styles.progressLast}`}
                    >
                      <ActivityProgress
                        activitySection={activitySection}
                        completedPercentage={
                          [
                            ACTIVITY_STATES.complete.id,
                            ACTIVITY_STATES.ceremony.id,
                            ACTIVITY_STATES.office_signoff.id
                          ].includes(get(state, 'value'))
                            ? 100
                            : 0
                        }
                      />
                    </div>
                  </div>
                </Card.Bottom>
              )}
            </Card.Content>
          </Card.Wrap>
        </ElevatedBox>
        {get(sectionIcon, 'assessment') &&
          !isAssessmentPositive && (
            <div className={styles.assessment}>
              <i className={`ico ico--info ${styles.assessmentIcon}`} />
              <FormattedHTMLMessage
                id="label.activity_ready_for_signoff"
                defaultMessage="This activity is ready for sign off."
              />
            </div>
          )}
        {setup && (
          <div className={styles.assessment} >
            <i className={`ico ico--info ${styles.assessmentIcon}`} />
              <span className={`${styles.clickable}`} onClick={() => handleOpenAcceptActivityModal()}>
              <FormattedHTMLMessage
                id="label.accept_becoming_assessor"
                defaultMessage="Become the assessor"
              />
               </span>
          </div>
        )}
        {revised && (
          <div className={styles.warning}>
            <i className={`ico ico--warning ${styles.warningIcon}`} />
            <span>
              <FormattedHTMLMessage
                id="label.activity_returned_by_award_leader"
                defaultMessage="Activity has been returned by your Award Leader."
              />
               </span>
          </div>
        )}

        {isAwardLeaderSignoff && (
          <div className={styles.assessment}>
            <i className={`ico ico--info ${styles.assessmentIcon}`} />
            <FormattedHTMLMessage
              id="label.activity_waiting_award_leader_signoff"
              defaultMessage="Activity is waiting for Award Leader signoff"
            />
          </div>
        )}
      </div>
    )
  }
}

export default ParticipantItemWrap
